import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useLocation, useNavigate } from "react-router-dom";
import InvestmentTimelineSummary from "../../Components/InvestmentTimelineSummary";
import InvestmentDetailDates from "../../Components/InvesmentDetailDates";
import Capital from "../../Components/Capital";
import InvestmentDetailsTable from "../../Components/InvestmentDetailsTable";
import RealEstateAmount from "../../Components/RealEstateAmount";
import SalesPublishSuccess from "../../Components/SalesPublishSuccess";
import UnitPublishing from "../../Components/UnitPublishing";
import PublishToSelectedUsers from "../../Components/PublishToSelectedUsers";
import PinConfirmation from "../../Components/PinConfirmation";
import { sellUnits } from "../../store/actions/realEstate/sellUnits";
import { useDispatch } from "react-redux";

const RealEstateSummary = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleToggleNotification = () => {
    setShowNotification((prev) => !prev);
  };

  const dispatch = useDispatch();
  const handleConfirm = ({
    otp,

    amount,
  }) => {
    const data = {
      data: {},
      // name: name,
      failed: () => {
        // setShowConfirmationModal(null);
        // setShowModal(showConfirmationModal?.showModalData);
      },
      cb: (response) => {
        setIsModalOpen({ modal: "SUCCESS" });
      },
    };

    dispatch(sellUnits(data));
  };

  return (
    <>
      <div className="flex flex-col bg-[#F9FAFA] gap-6 pt-3 pb-3 items-center min-h-screen">
        <Navbar type={3} handleNotification={handleToggleNotification} />

        <div className="w-[95%] h-full flex-wrap rounded-[12px] gap-10 p-6 md:p-10 bg-[#FFF] border-[#F2F2F2] border-[1.1px] drop-shadow-custom  max-w-[1664px] flex">
          <div className="flex w-full md:w-auto flex-col md:flex-[5]">
            <div
              onClick={() => navigate(-1)}
              className="flex cursor-pointer items-center"
            >
              <LiaAngleLeftSolid
                size={18}
                color="#131E3D"
                className="mx-[2px]  "
              />
              <h3 className="text-[14px] font-[400] text-[#131E3D]">Back</h3>
            </div>
            <Capital
              state={state}
              type={"REAL-ESTATE"}
              setIsModalOpen={setIsModalOpen}
            />
            <InvestmentDetailsTable type={"REAL-ESTATE"} state={state} />
          </div>
          <div className="flex flex-col md:flex-[4] w-full  md:w-auto  md:pt-6">
            <InvestmentTimelineSummary type={"REAL-ESTATE"} state={state} />
            <InvestmentDetailDates type={"REAL-ESTATE"} state={state} />
          </div>
        </div>
      </div>
      {isModalOpen?.modal === "SELL-INITIATED" ? (
        <div className="fixed top-0 left-0 inset-0 flex items-center justify-center bg-[rgba(19,30,61,0.4)] z-40">
          <UnitPublishing
            setIsModalOpen={setIsModalOpen}
            handleClose={() => {
              setIsModalOpen(false);
            }}
          />
        </div>
      ) : isModalOpen?.modal === "CONFIRMATION" ? (
        <div className=" top-0 left-0 w-screen h-screen z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
          <PinConfirmation
            handleClose={() => {
              setIsModalOpen(false);
            }}
            back={() => {
              // setShowConfirmationModal(null);
              // setShowModal(showConfirmationModal?.showModalData);
            }}
            handleSubmit={(otp) => {
              // handleConfirm({
              //   ...showConfirmationModal?.value,
              //   otp,
              //   opportunity,
              //   investment_product_id: opportunity?.id,
              // });
            }}
            buttonTitle={"Submit Investment"}
            subTitle={"Confirm your Halvest PIN to Invest"}
          />
        </div>
      ) : isModalOpen?.modal === "SELECTED_USER" ? (
        <div className="fixed top-0 left-0 inset-0 flex items-center justify-center bg-[rgba(19,30,61,0.4)] z-40">
          <PublishToSelectedUsers
            setIsModalOpen={setIsModalOpen}
            handleClose={() => {
              setIsModalOpen(false);
            }}
          />
        </div>
      ) : isModalOpen?.modal === "SUCCESS" ? (
        <div className="fixed top-0 left-0 inset-0 flex items-center justify-center bg-[rgba(19,30,61,0.4)] z-40">
          <SalesPublishSuccess
            handleClose={() => {
              setIsModalOpen(false);
            }}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default RealEstateSummary;
